<template>
  <div v-if="question.input.show">
    <b-row v-if="question.input.type === 'text' || question.input.type === 'email' || question.input.type === 'tel'">
      <b-col cols="12" md="8" offset-md="2">
        <div class="form-group slcb-toddy__dialog-form-group">
          <template functional v-if="question.input.type === 'tel'">
            <b-form-input :id="question.input.id" :type="question.input.type" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--arrow" v-model="fieldState" v-bind:class="{ 'slcb-toddy__dialog-input--filled': fieldState }" autocomplete="off" :state="validateState" pattern="\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$" v-mask="['(##) ####-####', '(##) #####-####']" v-focus autofocus required @keyup.enter="validate($event)" trim>
            </b-form-input>
          </template>

          <template functional v-else-if="question.input.type === 'email'">
            <b-form-input :id="question.input.id" :type="question.input.type" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--arrow" v-model="fieldState" v-bind:class="{ 'slcb-toddy__dialog-input--filled': fieldState }" autocomplete="off" :state="validateState" :pattern="emailRegex" v-focus autofocus required @keyup.enter="validate($event)" trim>
            </b-form-input>
          </template>

          <template functional v-else>
            <b-form-input :id="question.input.id" :type="question.input.type" class="slcb-toddy__dialog-input slcb-toddy__dialog-input--arrow" v-model="fieldState" v-bind:class="{ 'slcb-toddy__dialog-input--filled': fieldState }" autocomplete="off" :state="validateState" v-focus autofocus required @keyup.enter="validate($event)" trim>
            </b-form-input>
          </template>

          <b-btn v-on:click="validate($event)" variant="none" class="slcb-toddy__dialog-button-input">
            <img src="~@/assets/img/arrow_right.svg" alt="Continuar" />
          </b-btn>
          <label :for="question.input.id" class="slcb-toddy__dialog-label" v-bind:class="[validateState === false ? 'slcb-toddy__dialog-label--error' : '']">{{ question.input.label }}</label>
        </div>
      </b-col>
    </b-row>

    <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-else-if="question.input.type === 'options'">
      <b-col v-for="(option, index) in question.input.options" :key="index" class="text-center">
        <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="method($event, question, option.value)">{{ option.label }}</b-button>
      </b-col>
    </b-row>

    <b-row class="slcb-toddy__dialog-row slcb-toddy__dialog-row--eq-height" v-else>
      <b-col cols="12" md="6" lg="4" offset-lg="2">
        <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="method($event, question, true)">Sim</b-button>
      </b-col>
      <b-col cols="12" md="6" lg="4">
        <b-button variant="none" class="slcb-toddy__dialog-button" v-on:click="method($event, question, false)">Não</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'Input',
  props: ['question', 'method', 'field'],
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    },
    mask
  },
  data () {
    return {
      fieldState: null,
      validateState: null,
      emailRegex: ''
    }
  },
  watch: {
    field: function (val, oldVal) {
      this.fieldState = val
    },
    fieldState: function (val, oldVal) {
      this.validateState = null
      this.$emit('update:field', val)
    }
  },
  methods: {
    validate: function (event) {
      if (this.fieldState === null || this.fieldState.length <= 0) {
        this.validateState = false
        return false
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (this.question.input.type === 'email' && !emailRegex.test(this.fieldState)) {
        this.validateState = false
        return false
      }
      this.method(event, this.question, this.fieldState)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Input.vue